module.exports = "/desktop-app/assets/img/table-logo.png?8f5d4d4635dfa80cee8ac3795fdba770";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/icons/chat/table-logo.png
// module id = FYs1
// module chunks = 1